var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoriesCrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -4.44444,
    y: -4.44444,
    width: 48.8889,
    height: 48.8889
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.22px)",
      clipPath: "url(#bgblur_0_5445_229169_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 4.44444,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "black",
    fillOpacity: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5445_229169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.875 26H28.25V14.375C28.25 13.6788 27.9734 13.0111 27.4812 12.5188C26.9889 12.0266 26.3212 11.75 25.625 11.75H14V9.125C14 8.82663 13.8815 8.54048 13.6705 8.3295C13.4595 8.11853 13.1734 8 12.875 8C12.5766 8 12.2905 8.11853 12.0795 8.3295C11.8685 8.54048 11.75 8.82663 11.75 9.125V11.75H9.125C8.82663 11.75 8.54048 11.8685 8.3295 12.0795C8.11853 12.2905 8 12.5766 8 12.875C8 13.1734 8.11853 13.4595 8.3295 13.6705C8.54048 13.8815 8.82663 14 9.125 14H11.75V25.625C11.75 26.3212 12.0266 26.9889 12.5188 27.4812C13.0111 27.9734 13.6788 28.25 14.375 28.25H26V30.875C26 31.1734 26.1185 31.4595 26.3295 31.6705C26.5405 31.8815 26.8266 32 27.125 32C27.4234 32 27.7095 31.8815 27.9205 31.6705C28.1315 31.4595 28.25 31.1734 28.25 30.875V28.25H30.875C31.1734 28.25 31.4595 28.1315 31.6705 27.9205C31.8815 27.7095 32 27.4234 32 27.125C32 26.8266 31.8815 26.5405 31.6705 26.3295C31.4595 26.1185 31.1734 26 30.875 26ZM14.375 26C14.2755 26 14.1802 25.9605 14.1098 25.8902C14.0395 25.8198 14 25.7245 14 25.625V14H25.625C25.7245 14 25.8198 14.0395 25.8902 14.1098C25.9605 14.1802 26 14.2755 26 14.375V26H14.375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_5445_229169_clip_path",
    transform: "translate(4.44444 4.44444)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5445_229169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoriesCrop);
export default __webpack_public_path__ + "static/media/stories-crop.7277a62eb2d20a53584524aeba3b04c5.svg";
export { ForwardRef as ReactComponent };